import PropTypes from 'prop-types';
import React from 'react';
import './styles.css';
import defaultAvatar from './avatar_default.png';

function Avatar(props) {
  let bgImg = 'none';

  if (props.src) {
    bgImg = `url(${props.src})`;
  } else {
    bgImg = props.noDefaultAvatar ? 'none' : `url(${defaultAvatar})`;
  }

  const size = props.size ? props.size : 40;

  const avatarStyle = {
    backgroundImage: bgImg,
    width: `${size}px`,
    height: `${size}px`
  };

  return (
    <span className={['avatar', props.className].join(' ')} style={avatarStyle} />
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  noDefaultAvatar: PropTypes.bool
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/avatar/index.js